import React from 'react';
import './Button.css'

const Button = (props) => {
    return (<>
    <div className= {props.css4} > {props.text} </div>
    </>);
}
 
export default Button;